const state = {
	user: null,
	role: null,
	locale: 'en-US',
	notificationNum: 0			// 消息通知数量
}

const getters = {
	user: state => {
		let user = JSON.parse(localStorage.getItem('SIP-user'));
		if (user) {
			state.user = user;
		}
		return state.user;
	},
	role: state => {
		let role = JSON.parse(localStorage.getItem('SIP-role'));
		if (role) {
			state.role = role;
		}
		return state.role;
	},
	locale: state => {
		let locale = localStorage.getItem("SIP-locale");
		if (locale) {
			state.locale = locale;
		}
		return state.locale;
	},
	notificationNum: state => {
		return state.notificationNum;
	}
}

const actions = {
	userHandler(context, payload){
		context.commit('userHandler', payload);
	},
	roleHandler(context, payload){
		context.commit('roleHandler', payload);
	},
	localeHandler(context, payload){
		context.commit('localeHandler', payload);
	},
	timeZoneHandler(context, payload){
		context.commit('timeZoneHandler', payload);
	},
	imageHandler(context, payload){
		context.commit('imageHandler', payload);
	},
	notificationNumHandler(context, payload){
		context.commit('notificationNumHandler', payload);
	},
	readIndexHandler(context, payload){
		context.commit('readIndexHandler', payload);
	}
}

const mutations = {
	userHandler(state, user){
		localStorage.setItem('SIP-user', JSON.stringify(user));
		state.user = user;
	},
	roleHandler(state, role){
		localStorage.setItem('SIP-role', JSON.stringify(role));
		state.role = role;
	},
	localeHandler(state, locale){
		localStorage.setItem("SIP-locale", locale);
		state.locale = locale;
	},
	timeZoneHandler(state, timeZone){
		state.user.timeZoneId = timeZone.timeZoneId;
		state.user.timeOffset = timeZone.timeOffset;
	},
	imageHandler(state, image){
		state.user.image = image;
	},
	notificationNumHandler(state, notificationNum){
		state.notificationNum = notificationNum;
	},
	readIndexHandler(state, readIndex){
		state.user.readIndex = readIndex;
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user/index.js